/**
 * frontend/src/constants/notificationsModuleUrls.js
 * URL для modouls NOTIFICATIONS (API-only backend + App UI/proxy).
 */
const appOrigin = (() => {
  const raw = String(process.env.REACT_APP_API_URL || 'https://app.markbase.ru').replace(/\/+$/, '');
  try {
    return new URL(raw).origin;
  } catch (_e) {
    return 'https://app.markbase.ru';
  }
})();

export const NOTIFICATIONS_ORIGIN = (
  process.env.REACT_APP_NOTIFICATIONS_PUBLIC_URL || 'https://notifications.markbase.ru'
).replace(/\/+$/, '');

/** Прямой API vhost (S2S, health). Браузер inbox — через App proxy. */
export const NOTIFICATIONS_API_BASE =
  process.env.REACT_APP_NOTIFICATIONS_API_URL || `${NOTIFICATIONS_ORIGIN}/api/notifications/v1`;

/** Канон browser client (`notificationService.js`). */
export const NOTIFICATIONS_APP_PROXY_BASE = `${appOrigin}/api/notifications`;

export const NOTIFICATIONS_APP_INBOX = `${appOrigin}/notifications`;

export const NOTIFICATIONS_APP_CONNECTION = `${appOrigin}/notifications/connection`;

export const NOTIFICATIONS_APP_ADMIN = `${appOrigin}/admin/notifications`;

export const NOTIFICATIONS_DISPATCH_PATH = `${NOTIFICATIONS_API_BASE}/dispatch`;
